module.exports = __webpack_public_path__ + "img/o_1.0b0cb678.png";